export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Delete',
  isProcessing = false,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
         <div className="bg-white dark:bg-[#161616] border border-red-500/30 rounded-2xl p-6 max-w-md w-full shadow-2xl">
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">⚠️</div>
          <h3 className="blog-title text-3xl font-bold text-red-600 dark:text-red-400 mb-2">{title}</h3>
          <p className="text-gray-700 dark:text-gray-300">{message}</p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onConfirm}
            disabled={isProcessing}
            className="flex-1 px-6 py-3 bg-red-600 hover:bg-red-700 rounded-xl text-white font-bold transition-all shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
          >
              {isProcessing ? 'Processing...' : confirmLabel}
          </button>
          <button
            onClick={onClose}
            disabled={isProcessing}
            className="flex-1 px-6 py-3 bg-gray-200 dark:bg-[#0E0E0E] hover:bg-gray-300 dark:hover:bg-[#1F1F1F] rounded-xl text-gray-900 dark:text-gray-100 font-semibold transition-all disabled:opacity-60 disabled:cursor-not-allowed border border-transparent dark:border-gray-800"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
